const CDN_BASE = process.env.REACT_APP_CDN_PATH + "forrentca/";

export const CDN_INCLUDES = CDN_BASE + "includes/";
export const CDN_ASSETS = CDN_BASE + "assets/";
export const CDN_PROPERTIES = CDN_BASE + "properties/";

export const EQUAL_HOUSING_LOGO = "https://resources.swmc.com/swmc-images/Footer/equal-housing.png";

// Property photo filenames in properties.json keep their original extension
// (.jpg/.jpeg), but the uploaded S3 copies are all .webp under the same
// basename — swap the extension when building the URL.
export function propertyPhotoUrl(filename) {
  const basename = filename.replace(/\.[^./]+$/, "");
  return CDN_PROPERTIES + basename + ".webp";
}
